import { AutomationWizardStepProps } from "../../../AutomationsUtils";
import FormWizardFormWrapper from "../../../../Forms/FormWizard/FormWizardFormWrapper";
import { Controller, FormProvider, useForm } from "react-hook-form";
import PageFormWidget from "../../../../Forms/FormWizard/PageFormRenderer/PageFormWidget/PageFormWidget";
import PageFormButtons from "../../../../Forms/FormWizard/PageFormRenderer/PageFormButtons/PageFormButtons";
import "./TicketSchedulingStep.scss";
import { CheckBox } from "@SeemplicityDev/shared";
import SchedulerInput from "../../SchedulerInput";

const TicketSchedulingStep: React.FC<AutomationWizardStepProps> = ({
  defaultValues,
  onValidate = () => {},
  isSummary,
}) => {
  const methods = useForm({
    mode: "all",
    defaultValues: defaultValues,
  });

  const { handleSubmit, getValues, control } = methods;

  return (
    <FormProvider {...methods}>
      <FormWizardFormWrapper
        handleSubmit={handleSubmit}
        onSubmit={onValidate}
        getValues={getValues}
      >
        <PageFormWidget isSummary={isSummary}>
          <div className="ticket-scheduling-step-container">
            <SchedulerInput isSummary={isSummary} />
            {!isSummary && (
              <Controller
                name={"syncNow"}
                defaultValue={false}
                render={({ field: { value, onChange } }) => {
                  return (
                    <CheckBox
                      wrapperClassName={"sync-queue-checkbox"}
                      data-testid={"sync-now"}
                      checked={value}
                      label={"Sync Queue Now"}
                      alignLeft
                      onChange={(val: any, newValue: any) => onChange(newValue)}
                    />
                  );
                }}
                control={control}
              />
            )}
          </div>
        </PageFormWidget>
        {!isSummary && (
          <PageFormButtons data-testid="ticket-scheduling-step-buttons" />
        )}
      </FormWizardFormWrapper>
    </FormProvider>
  );
};

export default TicketSchedulingStep;
